<template>
  <wrapper-edit
    wrapper-width="100%"
    @back="paasPageBack"
    offsetHeight=110>
      <Form ref="paasForm" slot="form"
            :model="paasFormData"
            :rules="paasFormRules"
            :label-width="defaultLabelWidth">
        <Row>
          <FormItem label="分类名称：" prop="title" class="ivu-col-span-24" >
            <Input v-model="paasFormData.title"
                   clearable ></Input>
          </FormItem>
        </Row>
        <div class="edit-oper-toolbar">
          <mButton type="blue" @click="paasFormSubmit('paasForm','','submit')">提交</mButton>
          <mButton type="green" @click="paasFormSubmit('paasForm','','add')">继续添加</mButton>
          <mButton @click="paasPageBack">返回</mButton>
        </div>
      </Form>
    </wrapper-edit>
</template>
<script>
  import wrapperEdit from "@components/paas/wrapper-edit";
  import metaEdit from "@assets/js/meta-tree-edit.js";
  import mButton from '@components/button/m-button'
  export default {
    name: "edit",
    mixins:[metaEdit],
    components:{wrapperEdit,mButton},
    data(){
      return {
        serviceUrl:"/sys/image/category",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        currentNameFiledName: 'title',
        fieldName:'sys_image_category',
        paasFormData:{
          id:'',
          title:'',
          nodeCode:'',
          parentId:'',
          parentName:'',
          displayOrder:"",
          isDelete:"",
          icon:"",
        },
        paasFormRules:{
        },
        redirectName:"imageCategoryList",
        nextAddName:"imageCategoryEdit",
      }
    },
    methods:{
    }
  }
</script>
<style scoped>
  .whead {
    height: 38px;
    color: #636363;
    background: #f8f8f8;
    background: -webkit-gradient(linear, left top, left bottom, from(#f8f8f8),to(#e8e8e8));
    background: linear-gradient(to bottom, #f8f8f8 0%,#e8e8e8 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f8f8f8', endColorstr='#e8e8e8',GradientType=0 );
  }
  .wrapper{
    margin:0;
  }
  .ivu-form{
    width:80%;
    margin:0 auto;
  }
</style>
